import { esc } from './_helpers'

const { __, _x } = wp.i18n

// Formats as visuals: cards drawn to scale + portrait / landscape orientation.
// Drives the existing fields (#formatPreset/#fw/#fh, #qFormat) without touching their scripts.
export const initFormats = () => {
  const F = window.vnQuote.options.formats
  const FIXED = window.vnQuote.options.fixedFormats // no orientation for these formats
  const isCustom = (v) => v === 'custom' || v === 'autre'

  function setup(sel, cfg) {
    if (!sel) return
    const ui = document.createElement('div')
    ui.className = 'fmt-ui'
    ui.innerHTML = `<div class="fmt-orient" data-value="portrait" role="group" aria-label="${esc(__('Orientation', 'vn'))}">
        <button type="button" data-o="portrait" aria-pressed="true"><i class="o-p"></i>${esc(_x('Portrait', 'quote orientation', 'vn'))} <small>${esc(__('(upright)', 'vn'))}</small></button>
        <button type="button" data-o="paysage" aria-pressed="false"><i class="o-l"></i>${esc(_x('Landscape', 'quote orientation', 'vn'))} <small>${esc(__('(oblong)', 'vn'))}</small></button>
      </div><div class="fmt-cards"></div>`
    sel.after(ui)
    sel.classList.add('fmt-hidden-select')
    const cards = ui.querySelector('.fmt-cards'),
      orient = ui.querySelector('.fmt-orient')
    if (cfg.w && cfg.h) {
      // dimension labels
      ;[
        [cfg.w, __('Width (mm)', 'vn')],
        [cfg.h, __('Height (mm)', 'vn')],
      ].forEach(([el, t]) => {
        if (!el.closest('.field').querySelector('.fmt-lbl'))
          el.insertAdjacentHTML('beforebegin', `<div class="fmt-lbl">${esc(t)}</div>`)
      })
    }
    const keys = () => Array.from(sel.options).map((o) => o.value).filter(Boolean)
    const dimsOf = (k) => {
      const f = F[k]
      if (!f) return null
      if (FIXED.includes(k)) return [f.w, f.h]
      const a = Math.min(f.w, f.h),
        b = Math.max(f.w, f.h)
      return orient.dataset.value === 'paysage' ? [b, a] : [a, b]
    }
    let sig = ''
    function render() {
      const ks = keys(),
        std = ks.filter((k) => !isCustom(k) && F[k])
      if (ks.join(',') !== sig) {
        // new product
        sig = ks.join(',')
        orient.hidden = !std.length || std.every((k) => FIXED.includes(k))
        const naturalLandscape = std.length && std.every((k) => F[k].w > F[k].h)
        setOrient(naturalLandscape ? 'paysage' : 'portrait', false)
      }
      const max = Math.max(1, ...std.map((k) => Math.max(F[k].w, F[k].h)))
      const S = 96 / max
      cards.innerHTML = ks
        .map((k) => {
          if (isCustom(k)) {
            return (
              `<button type="button" class="fmt-card custom" data-k="${k}"><span class="fmt-draw"><span class="fmt-sheet" style="width:46px;height:62px">+</span></span>` +
              `<span class="fmt-name">${esc(_x('Custom', 'quote format', 'vn'))}</span><span class="fmt-dim">${esc(__('your dimensions', 'vn'))}</span></button>`
            )
          }
          const [w, h] = dimsOf(k)
          return (
            `<button type="button" class="fmt-card" data-k="${k}"><span class="fmt-draw"><span class="fmt-sheet" style="width:${Math.max(12, Math.round(w * S))}px;height:${Math.max(12, Math.round(h * S))}px"></span></span>` +
            `<span class="fmt-name">${esc(F[k].label.split(' (')[0])}</span><span class="fmt-dim">${w} × ${h} mm</span></button>`
          )
        })
        .join('')
      cards.hidden = !ks.length
      mark()
    }
    function mark() {
      cards
        .querySelectorAll('.fmt-card')
        .forEach((c) => c.classList.toggle('on', c.dataset.k === sel.value))
    }
    function apply() {
      // reports the orientation in the dimensions
      if (cfg.w && cfg.h && F[sel.value]) {
        const [w, h] = dimsOf(sel.value)
        cfg.w.value = w
        cfg.h.value = h
      }
    }
    function setOrient(o, reapply = true) {
      const prev = orient.dataset.value
      orient.dataset.value = o
      orient
        .querySelectorAll('button')
        .forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.o === o)))
      if (!reapply) return
      if (cfg.w && cfg.h && isCustom(sel.value) && prev !== o && cfg.w.value && cfg.h.value) {
        const t = cfg.w.value
        cfg.w.value = cfg.h.value
        cfg.h.value = t
      }
      apply()
      render()
    }
    orient.addEventListener('click', (e) => {
      const b = e.target.closest('button')
      if (b) setOrient(b.dataset.o)
    })
    cards.addEventListener('click', (e) => {
      const c = e.target.closest('.fmt-card')
      if (!c) return
      sel.value = c.dataset.k
      sel.dispatchEvent(new Event('change', { bubbles: true }))
      if (isCustom(c.dataset.k)) (cfg.focus || cfg.w)?.focus()
      else apply()
      mark()
    })
    new MutationObserver(render).observe(sel, { childList: true })
    ;['input', 'change'].forEach((ev) =>
      document.addEventListener(ev, () => setTimeout(mark, 0))
    )
    render()
  }

  setup(document.getElementById('formatPreset'), {
    w: document.getElementById('fw'),
    h: document.getElementById('fh'),
  })
  setup(document.getElementById('qFormat'), {
    focus: document.querySelector('[data-q="quick.width"]'),
  })
}
